"use client";
import { useState, Fragment } from "react";
import {
  Dialog,
  Transition,
  TransitionChild,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import Image from "next/image";
import { Icon } from "@iconify/react";
import { PrismicNextImage } from "@prismicio/next";

export default function VideoModal({ thumbnailSrc, videoSrc }) {
  const [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <div className="text-center w-full text-center">
      <div className="text-center w-full mx-auto mt-16 text-center">
        <PrismicNextImage
          field={thumbnailSrc}
          alt="Video Thumbnail"
          className="cursor-pointer mx-auto w-full max-w-6xl h-auto"
          onClick={openModal}
        />
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-700" onClose={closeModal}>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-80"onClick={closeModal} />
          </TransitionChild>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <button
                onClick={closeModal}
                className="absolute top-1 right-1 p-2 bg-transparent rounded-full"
              >
                <Icon
                  icon="mingcute:close-fill"
                  className="w-6 h-6 text-white"
                />
              </button>
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <DialogPanel className="w-full transform overflow-hidden p-6 text-center align-middle transition-all" onClick={closeModal}>
                  <div className="relative pb-9/16 mx-auto text-center">
                    <iframe
                      className="embedly-embed mx-auto w-full md:w-[940px]"
                      src={videoSrc}
                      width="100%"
                       height="523"
                      scrolling="no"
                      title="Vimeo embed"
                      frameBorder="0"
                      loading="lazy"
                      allow="autoplay; fullscreen; encrypted-media; picture-in-picture;"
                      allowFullScreen
                    ></iframe>
                     <button
                onClick={closeModal}
                className="mt-10 p-2 bg-transparent rounded-full text-white"
              >
               Close Video
              </button>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
